module.exports = __webpack_public_path__ + "static/media/haircut.7a3405d9.svg";